import { LogOut, User } from 'lucide-react'
import { useAuthStore } from '@/lib/stores/authStore'
import { Button } from '@/components/ui'

export function Header() {
  const { user, logout } = useAuthStore()

  return (
    <header className="sticky top-0 z-30 h-16 bg-white border-b border-gray-200">
      <div className="flex items-center justify-between h-full px-6">
        {/* Breadcrumb / Title - can be enhanced later */}
        <div />

        {/* User menu */}
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <User className="w-4 h-4" />
            <span>{user?.email}</span>
          </div>
          <Button variant="ghost" size="sm" onClick={logout}>
            <LogOut className="w-4 h-4 mr-2" />
            Esci
          </Button>
        </div>
      </div>
    </header>
  )
}
